import React, { FC, ImgHTMLAttributes } from 'react';

const LazyImg: FC<Omit<ImgHTMLAttributes<HTMLImageElement>, 'loading'>> = props => (
  <img alt="" {...props} loading="lazy" />
);

export default LazyImg;
